import * as z from "zod/v4";

export const deleteSegment = {
  name: "deleteSegment" as const,
  input: z.string(),
  output: z.null(),
};
